import api from "../../utils/api";
import {GetNextOfKin} from "./selfServiceSlice";
import {UpdateEmployerDetailsI} from "../../interfaces";

const baseEndpoint = process.env.REACT_APP_API_BASE_URL
    ? process.env.REACT_APP_API_BASE_URL
    : "";
export const baseAPI = api(baseEndpoint);
const selfServicesService = {
    transferRSA: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/TransferRSA`, payload);
    },
    getAllEmployer: async (searchTerm: any) => {
        const searchString = searchTerm ? encodeURIComponent(searchTerm) : ""
        return baseAPI.get(`/v2/SelfServices/getallemployer?Search=${searchString}`);
    },
    getAllPFA: async () => {
        return baseAPI.get(`/v2/SelfServices/getallpfa`);
    },
    getBanks: async () => {
        return baseAPI.get(`/Mobile/Benefits/getBanks`);
    },

    getAggregators: async () => {
        return baseAPI.get(`/v2/SelfServices/aggregator`);
    },
    getDashboardBalances: async (pin: any) => {
        return baseAPI.get(`/v2/SelfServices/balancedashboard?pin=${pin}`);
    },
    getKYCStatus: async (pin: any) => {
        return baseAPI.get(`/v2/SelfServices/KYCStatus?pin=${pin}`);
    },
    validateEmail: async () => {
        return baseAPI.get(`/v2/SelfServices/validateemail`);
    },
    verifyEmailAddress: async (payload: { verificationCode: string }) => {
        return baseAPI.post(`/v2/SelfServices/verifyemail`, payload);
    },
    verifyPhoneNumber: async (payload: { verificationCode: string }) => {
        return baseAPI.post(`/Mobile/SelfService/VerifyPhoneNumber`, payload);
    },
    validatePhoneNumber: async () => {
        return baseAPI.get(`/Mobile/SelfService/GetPhoneNumberVerificationCode`);
    },
    generateRecaptureLink: async (pin: any) => {
        return baseAPI.get(`/WhatsApp/WAService/GenerateRecaptureLink?pin=${pin}`);
    },
    getRecaptureDetails: async () => {
        return baseAPI.get(`/Recapture/details`);
    },
    getRegistrationDetails: async () => {
        return baseAPI.get(`/Registration/details`);
    },
    submitRegistration: async (payload: FormData) => {
        return baseAPI.post(`/Registration/save`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    saveRegistrationDraft: async (payload: FormData) => {
        payload.set('SaveAsDraft', 'true');
        return baseAPI.post(`/Registration/save`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    submitRecapture: async (payload: FormData) => {
        return baseAPI.post(`/Recapture/initiaterecapture`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    saveRecaptureDraft: async (payload: FormData) => {
        payload.set('SaveAsDraft', 'true');
        return baseAPI.post(`/Recapture/initiaterecapture`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    validateRecapturePassport: async (file: File) => {
        const form = new FormData();
        form.append('file', file);
        return baseAPI.post(`/Recapture/validate-passport`, form, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    updateKYC: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/kyc`, payload);
    },
    getUserInfo: async () => {
        return baseAPI.get(`/Mobile/SelfService/GetUserInfo`);
    },
    getNextOfKin: async () => {
        return baseAPI.get(`/v2/SelfServices/getnok`);
    },
    updateNextOfKin: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/updatenok`, payload);
    },
    createNextOfKin: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/createnok`, payload);
    },
   
    getRelationship: async () => {
        return baseAPI.get(`/v2/SelfServices/relationship`);
    },
    getEmployerBranchDetails: async () => {
        return baseAPI.get(`/v2/SelfServices/employerbranchdetails`);
    },
    getallemployerbranch: async (employerId: number) => {
        return baseAPI.get(`/v2/SelfServices/getallemployerbranch?employerId=${employerId}`);
    },
    getdocumentdefinitions: async (searchText: string) => {
        return baseAPI.get(`/v2/SelfServices/getdocumentdefinitions?Search=${searchText}`);
    },

    
    updateemployerdetails: async (payload: FormData) => {
        // const formData = new FormData();
        // formData.append('employerId', payload.employerId.toString());
        // formData.append('employerBranchId', payload.employerBranchId.toString());
        return baseAPI.post(`/v2/SelfServices/updateemployerdetails`, payload, {
            headers: {
              'Content-Type': 'multipart/form-data', // Set the content type for FormData
            },
          });
    },
    employerConfirmation: async () => {
        return baseAPI.post(`/v2/SelfServices/employerconfirmation`);
    },
    pdo: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/pdo`, payload);
    },
    getDepartment: async () => {
        return baseAPI.get(`/v2/SelfServices/department`);
    },
    checkBenefitEligibility: async (payload: {type: number}) => {
        return baseAPI.post(`/Mobile/Benefits/eligibility`, payload);
    },
    initiateBenefitsApplication: async (payload: any) => {
        return baseAPI.post(`/Mobile/Benefits/initiate`, payload);
    },
    virtualNin: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/virtualnin`, payload);
    },


    mpppay: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/mpppay`, payload);
    },
    myMemorableDays: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/memorableday`, payload);
    },
    missingMonths: async (pin: any) => {
        return baseAPI.get(`/v2/SelfServices/missingmonths?pin=${pin}`);
    },
    pensionCalculator: async (payload: any) => {
        return baseAPI.post(`/Mobile/Benefits/PensionCalculator`, payload);
    },

    AcceptPrivacyPolicy: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/privacy`, payload);
    },

    GetPrivacyPolicyStatus: async (payload: any) => {
        return baseAPI.get(`/v2/SelfServices/getprivacy`);
    },


    retireePensionCalculator: async (payload: any) => {
        return baseAPI.post(`/Mobile/Benefits/RetireePensionCalculator`, payload);
    },
    fundTransfer: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/fundtransfer`, payload);
    },
    completeFundTransfer: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/completefundtransfer`, payload);
    },
    trackBenefit: async (pin: any) => {
        return baseAPI.get(`/v2/SelfServices/trackbenefit?pin=${pin}`);
    },
    benefitStatus: async (pin: any) => {
        return baseAPI.get(`/v2/SelfServices/benefitstatus?pin=${pin}`);
    },
    updatePasscode: async (payload: any) => {
        return baseAPI.post(`/Mobile/SelfService/UpdatePasscode`, payload);
    },

    getOldPasscode: async (payload: any) => {
        return baseAPI.get(`/Mobile/SelfService/GetPasscode`, payload);
    },
    changePassword: async (payload: any) => {
        return baseAPI.post(`/Mobile/Accounts/ChangePassword`, payload);
    },
    subscriptionGroup: async (payload: any) => {
        return baseAPI.post(`/Mobile/SelfService/SubscriptionGroup`, payload);
    },
    getSubscriptionGroup: async () => {
        return baseAPI.get(`/Mobile/SelfService/GetSubscriptionGroup`);
    },
    updateBiodata: async (payload: any) => {
        return baseAPI.post(`/Mobile/SelfService/UpdateBiodata`, payload);
    },
    privacy: async (payload: any) => {
        return baseAPI.post(`/v2/SelfServices/privacy`, payload);
    },
    CORGRequest: async (payload: any) => {
        return baseAPI.post(`/Mobile/SelfService/CORGRequest`, payload);
    },
};
export default selfServicesService;
